import { useUser } from "@components/user-context";
import { type DataTypeProvider } from "@devexpress/dx-react-grid";
import { formatting } from "@north-beam/nb-common";

export const Currency = ({
  column,
  row,
}: DataTypeProvider.ValueFormatterProps) => {
  const { user } = useUser();
  return (
    <div className="px-2 flex justify-end items-center w-full h-full">
      {formatting.formatCurrency(row[column.name], {
        code: user.currencies.currentCurrency,
      })}
    </div>
  );
};
